import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
  Menu,
  MenuItem,
  Tooltip,
  Avatar,
} from "@mui/material";
import { MBAppBar } from "@mercedes-benz/mbui-comps";
import MenuIcon from "@mui/icons-material/Menu";
import AddIcon from "@mui/icons-material/Add";
import PropTypes from "prop-types";
import { AppConfig } from "../AppConfig";
import { ThemeSwitchToggle } from "./ThemeSwitchToggle";
import { PopUpTask } from "../components/PopUpTask";
import { StorageKey } from "../auth/DataService";

// import { MBProfileMenuItem } from "./MBMenu.ts";
import { ListItemIcon } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { DataService } from "../auth/DataService";

const PageNavBar = ({ onMenuBtnClick }) => {
  // const { activeThemeID, setActiveThemeID } = useMBUITheme();
  const [isTaskPopupOpen, setTaskPopupOpen] = useState(false);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  let value = localStorage.getItem(StorageKey.userInfo_app_id);
  let app_id = "Applikations-ID: " + value;

  value = localStorage.getItem(StorageKey.userInfo_sub);
  let sub = "EMEA-ID: " + value;

  value = localStorage.getItem(StorageKey.userInfo_name);
  let name = "Name: " + value;

  value = localStorage.getItem(StorageKey.userInfo_email);
  let email = "E-Mail: " + value;

  var ett_group = "";
  value = localStorage.getItem(StorageKey.userInfo_ett_group);
  if (value) {
    ett_group = "Rollen: " + value.split(",");
  } else {
    ett_group = "Rollen: " + value;
  }

  const onClickLogout = () => {
    DataService.logout();
  };

  const settings = [
    app_id,
    sub,
    name,
    email,
    ett_group,
    <ListItemIcon onClick={onClickLogout}>
      <LogoutIcon />
      Abmelden
    </ListItemIcon>,
  ];

  const handleCreateTask = () => {
    setTaskPopupOpen(true);
  };

  const handleTaskPopupClose = () => {
    setTaskPopupOpen(false);
  };

  const handleOpenUserMenu = (event) => {
    console.log("Event: " + event);
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <MBAppBar
          enableColorOnDark
          position="fixed"
          logoShowUpBreakpoint="md"
          rightContent={
            <Box sx={{ justifyContent: "end", display: "flex" }}>
              {/* <Button
                variant="text"
                disableElevation
                startIcon={<AddIcon sx={{ fontSize: "large" }} />}
                style={{ display: "flex", alignItems: "center" }}
                onClick={handleCreateTask}
              >
                <span className="button-text">Create Task</span>
              </Button> */}
              <ThemeSwitchToggle showCaption={true} />
              <Tooltip title="Open settings">
                <IconButton
                  onClick={handleOpenUserMenu}
                  sx={{ paddingLeft: 1 }}
                >
                  <Avatar
                    alt={localStorage.getItem(StorageKey.userInfo_name)}
                    src="/static/images/avatar/2.jpg"
                  />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem key={setting} onClick={handleCloseUserMenu}>
                    <Typography variant="body2" textAlign="center">
                      {setting}
                    </Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          }
          leftContent={
            <Stack
              direction={"row"}
              justifyContent={"flex-start"}
              alignItems={"center"}
            >
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  onMenuBtnClick();
                }}
              >
                <MenuIcon fontSize={"large"} />
              </IconButton>
              <Typography variant="h6" noWrap component="div">
                {AppConfig.appName}
              </Typography>
            </Stack>
          }
        />
      </Box>
      <PopUpTask isOpen={isTaskPopupOpen} onClose={handleTaskPopupClose} />
      <style jsx>{`
        /* Hide text on small screens */
        @media (max-width: 600px) {
          .button-text {
            display: none;
          }
        }
      `}</style>
    </>
  );
};

PageNavBar.propTypes = {
  onMenuBtnClick: PropTypes.func,
};

PageNavBar.defaultProps = {};

export { PageNavBar };
